import { ApiContextType } from './api-context';
import { Content, Group } from './typings';

export const updateGroupName = (api: ApiContextType, id: string, name: string) => {
    return api.post(`/content/${id}`, { name })
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const updateGroupOrder = (api: ApiContextType, id: string, contentList: Content[]) => {
    return api.post(`/content/${id}/order`, { contentList })
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const addToGroup = (api: ApiContextType, id: string, content: Content) => {
    return api.post(`/content/${id}/move`, content)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const createInGroup = (api: ApiContextType, id: string, content: Content) => {
    return api.put(`/content/${id}/create`, content)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const deleteGroup = (api: ApiContextType, id: string) => {
    return api.del(`/group/${id}`)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const fetchAllContent = (api: ApiContextType): Promise<Content[]> => {
    return api.get('/content/all')
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchGroup = (api: ApiContextType, id: any): Promise<Group> => {
    return api.get(`/content/${id || 0}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};
